import React from "react";

const RequiredAsterisk = () => {
  return <span className="text-red-600">*</span>;
}

export default RequiredAsterisk
